export default {"src":"/_next/static/media/light_icon.42c47c12.svg","height":35,"width":36,"blurWidth":0,"blurHeight":0};